import React from 'react'
import StatisticsComp from '../../components/Statistics';

function Statistics() {
  return (
    <StatisticsComp />
  )
}

export default Statistics;